import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ChecklistHeader, ChecklistHeaderCreateParams, ChecklistHeaderFindAllParams } from '../core/type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { ChecklistHeaderService } from '../core/service';
import { User } from '../../user/core/type';

@Injectable()
export class ChecklistHeaderApiService implements ChecklistHeaderService {
  private readonly defaultUrl = `${environment.apiHost}/checklistHeaders`;

  constructor(private httpClient: HttpClient) {}

  update(id: number, data: Partial<ChecklistHeader>): Observable<void> {
    return this.httpClient.patch<void>(`${this.defaultUrl}/${id}`, data);
  }

  getById(id: number): Observable<ChecklistHeader> {
    return this.httpClient.get<ChecklistHeader>(`${this.defaultUrl}/${id}`);
  }

  findAll(
    filter?: ChecklistHeaderFindAllParams | undefined
  ): Observable<PaginatedResponse<ChecklistHeader>> {
    return this.httpClient.get<PaginatedResponse<ChecklistHeader>>(this.defaultUrl, {
      params: { ...filter },
    });
  }

  create(data: Omit<ChecklistHeaderCreateParams, 'id'>) {
    return this.httpClient.post<void>(this.defaultUrl, data);
  }

  delete(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
